"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.record = void 0;
function record(value) {
    const r = Object.create(null);
    return (value ? Object.assign(r, value) : r);
}
exports.record = record;
//# sourceMappingURL=record.js.map